import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import messages from "./local/index";

// Supported languages for Forwaro — 3 Chinese-capable + Japanese + Arabic (RTL) + 4 European.
// Keep ordering in sync with LanguageSwitcher presentation.
export const SUPPORTED_LANGS = [
  { code: "en", label: "English", dir: "ltr" as const },
  { code: "zh-Hant", label: "繁體中文", dir: "ltr" as const },
  { code: "zh-Hans", label: "简体中文", dir: "ltr" as const },
  { code: "ja", label: "日本語", dir: "ltr" as const },
  { code: "ar", label: "العربية", dir: "rtl" as const },
  { code: "de", label: "Deutsch", dir: "ltr" as const },
  { code: "fr", label: "Français", dir: "ltr" as const },
  { code: "es", label: "Español", dir: "ltr" as const },
  { code: "it", label: "Italiano", dir: "ltr" as const },
];

export const RTL_LANGS = SUPPORTED_LANGS.filter((l) => l.dir === "rtl").map(
  (l) => l.code,
);

export const applyDocumentDirection = (lang: string) => {
  if (typeof document === "undefined") return;
  const dir = RTL_LANGS.includes(lang) ? "rtl" : "ltr";
  document.documentElement.setAttribute("dir", dir);
  document.documentElement.setAttribute("lang", lang);
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    supportedLngs: SUPPORTED_LANGS.map((l) => l.code),
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "forwaro.lang",
    },
  });

// Sync document direction with language at init and on every change.
applyDocumentDirection(i18n.language || "en");
i18n.on("languageChanged", (lng) => applyDocumentDirection(lng));

export default i18n;
